export const PROJECTS = [
  {
    slug: "elegant-elysium",
    collection: "dubai",
    img1: "/portfolio/elysium-1.jpg",
    img2: "/portfolio/elysium-2.jpg",
    gallery: [1, 2, 3, 4, 5, 6, 7, 8].map((i) => `/portfolio/elysium/img-${i}.jpg`),
  },
  {
    slug: "art-deco-delights",
    collection: "dubai",
    img1: "/portfolio/artdeco-1.jpg",
    img2: "/portfolio/artdeco-2.jpg",
    gallery: [1, 2, 3, 4, 5, 6, 7, 8].map((i) => `/portfolio/artdeco/img-${i}.jpg`),
  },
  {
    slug: "whimsical-wonderland",
    collection: "dubai",
    img1: "/portfolio/whimsical-1.jpg",
    img2: "/portfolio/whimsical/img-2.jpg",
    gallery: [1, 2, 3, 4, 5].map((i) => `/portfolio/whimsical/img-${i}.jpg`),
  },
  {
    slug: "timeless-traditions",
    collection: "dubai",
    img1: "/portfolio/timeless-1.jpg",
    img2: "/portfolio/timeless-2.jpg",
    gallery: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => `/portfolio/timeless/img-${i}.jpg`),
  },
  {
    slug: "zen-retreat",
    collection: "dubai",
    img1: "/portfolio/zen-1.jpg",
    img2: "/portfolio/zen/img-3.jpg",
    gallery: [1, 2, 3, 4, 5, 6, 7, 8].map((i) => `/portfolio/zen/img-${i}.jpg`),
  },
  {
    slug: "sophisticated-lines",
    collection: "dubai",
    img1: "/portfolio/sophisticated-1.jpg",
    img2: "/portfolio/sophisticated-2.jpg",
    gallery: [1, 2, 3, 4, 5, 6, 7, 8].map((i) => `/portfolio/sophisticated/img-${i}.jpg`),
  },
  {
    slug: "mid-century-marvel",
    collection: "dubai",
    img1: "/portfolio/midcentury-1.jpg",
    img2: "/portfolio/midcentury/img-2.jpg",
    gallery: [1, 2, 3, 4, 5, 6, 7, 8].map((i) => `/portfolio/midcentury/img-${i}.jpg`),
  },
  {
    slug: "divine-serenity",
    collection: "dubai",
    img1: "/portfolio/serenity-1.jpg",
    img2: "/portfolio/serenity/img-2.jpg",
    gallery: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => `/portfolio/serenity/img-${i}.jpg`),
  },
];

export const INDIA_PROJECTS = [
  {
    slug: "rajendra-raj-chennai",
    collection: "india",
    img1: "/portfolio/rajendra/img-1.jpg",
    img2: "/portfolio/rajendra/img-2.jpg",
    gallery: [1, 2, 3, 4, 5, 6, 7].map((i) => `/portfolio/rajendra/img-${i}.jpg`),
  },
  {
    slug: "rana-shetty-bangalore",
    collection: "india",
    img1: "/portfolio/shetty/img-1.jpg",
    img2: "/portfolio/shetty/img-2.jpg",
    gallery: [1, 2, 3, 4, 5, 6].map((i) => `/portfolio/shetty/img-${i}.jpg`),
  },
  {
    slug: "sinha-delhi",
    collection: "india",
    img1: "/portfolio/sinha/img-1.jpg",
    img2: "/portfolio/sinha/img-2.jpg",
    gallery: [1, 2, 3, 4].map((i) => `/portfolio/sinha/img-${i}.jpg`),
  },
];

export const ALL_PROJECTS = [...PROJECTS, ...INDIA_PROJECTS];
